
import React, { Fragment, useState, useCallback, useRef, useEffect } from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

import Dropzone from "react-dropzone";
import styled, { css } from "styled-components";

import { makeStyles } from '@material-ui/core/styles';

import {
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    Box,
    Grid,
    Button,
    colors
} from '@material-ui/core';


const dragActive = css`
  border-color: #78e5d5;
`;

const dragReject = css`
  border-color: #e57878;
`;

export const DropContainer = styled.div.attrs({
    className: "dropzone"
})`
  border: 2px dashed #ddd;
  border-radius: 4px;
  cursor: pointer;
  transition: height 0.2s ease;
  ${props => props.isDragActive && dragActive};
  ${props => props.isDragReject && dragReject};
`;

const messageColors = {
    default: "#00A0EF",
    error: "#e57878",
    success: "#78e5d5"
};

export const UploadMessage = styled.p`
  display: flex;
  color: ${props => messageColors[props.type || "default"]};
  justify-content: center;
  align-items: center;
  padding: 15px 0;
`;


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: colors.yellow[50],
        minHeight: 50,
        marginBottom: '10px'
    }
}));

const allowedMimes = [
    "image/jpeg",
    "image/jpg",
    "image/gif",
    "image/tif",
    "image/png",
    "image/bmp",
    "image/svg+xml"
];


const EditImage = ({ item, open, close, save }) => {

    const classes = useStyles();

    const previewCanvasRef = useRef(null);
    const imgRef = useRef();

    const [upImg, setUpImg] = useState(null);
    const [crop, setCrop] = useState({ unit: '%', width: 30 });
    const [completedCrop, setCompletedCrop] = useState(null);

    const uploadFileBeforeSave = async (item, canvas, crop) => {
        await canvas.toBlob(function (blob) {
            save(item, blob);
        });
    }

    const onAcceptedFile = (files) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => setUpImg(reader.result));
        reader.readAsDataURL(files[0]);
    }

    const onLoad = useCallback((img) => {
        imgRef.current = img;
    }, []);

    useEffect(() => {
        if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
            return;
        }

        const image = imgRef.current;
        const canvas = previewCanvasRef.current;
        const crop = completedCrop;

        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        const ctx = canvas.getContext('2d');
        const pixelRatio = window.devicePixelRatio;

        canvas.width = crop.width * pixelRatio * scaleX;
        canvas.height = crop.height * pixelRatio * scaleY;

        ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        ctx.imageSmoothingQuality = 'high';

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width * scaleX,
            crop.height * scaleY
        );

    }, [completedCrop]);

    const renderDragMessage = (isDragActive, isDragReject) => {
        if (!isDragActive) {
            return <UploadMessage>
                <Typography>
                    Arraste arquivos aqui...
                </Typography>
            </UploadMessage>;
        }

        if (isDragReject) {
            return <UploadMessage type="error">
                <Typography>
                    Arquivo não suportado...
                </Typography>
            </UploadMessage>;
        }

        return <UploadMessage type="success">
            <Typography>
                Solte os arquivos aqui..
            </Typography>
        </UploadMessage>;
    };

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="lg" fullWidth >

                <DialogTitle>
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Cortar Imagem
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Grid
                        container
                    >

                        <Grid
                            item
                            md={12}
                            xs={12}>

                            <Dropzone accept={allowedMimes} onDropAccepted={onAcceptedFile}
                                maxFiles={1}
                                multiple={false}
                                canCancel={false}>
                                {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
                                    <DropContainer className={classes.root}
                                        {...getRootProps()}
                                        isDragActive={isDragActive}
                                        isDragReject={isDragReject}
                                    >
                                        <input {...getInputProps()} />
                                        {renderDragMessage(isDragActive, isDragReject)}
                                    </DropContainer>
                                )}
                            </Dropzone>

                        </Grid>

                        <Grid
                            item
                            md={12}
                            xs={12}

                        >
                            <Grid
                                container
                                spacing={5}
                            >

                                <Grid
                                    item
                                    md={6}
                                    xs={12}

                                >
                                    <ReactCrop
                                        style={{
                                            borderStyle: 'solid',
                                            borderColor: 'lightblue',
                                            borderWidth: '2px',
                                            minWidth: '100%',
                                            minHeight: 600,
                                            maxHeight: 600
                                        }}
                                        ruleOfThirds
                                        src={upImg}
                                        crop={crop}
                                        onImageLoaded={onLoad}
                                        onComplete={(cropped) => setCompletedCrop(cropped)}
                                        onChange={(cropped) => setCrop(cropped)}
                                    />

                                </Grid>

                                <Grid
                                    item
                                    md={6}
                                    xs={12}
                                >
                                    <div>
                                        <canvas
                                            style={{
                                                borderStyle: 'dashed',
                                                borderColor: 'lightblue',
                                                borderWidth: '2px',
                                                width: '100%',
                                                minHeight: 600,
                                                maxHeight: 600,
                                            }}
                                            ref={previewCanvasRef}
                                        // Rounding is important so the canvas width and height matches/is a multiple for sharpness.
                                        />
                                    </div>

                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>

                </DialogContent>

                <Divider />
                <DialogActions>
                    <Box my={1}></Box>
                    <Box my={1}>
                        <Grid container
                            direction="row"
                            justifyContent="flex-end"
                            alignItems="baseline"
                            spacing={1}  >
                            <Grid item >
                                <Button
                                    color="secondary"
                                    size="small"
                                    type="submit"
                                    variant="contained"
                                    onClick={() => { uploadFileBeforeSave(item, previewCanvasRef.current, completedCrop) }}>
                                    Enviar
                                </Button>
                            </Grid>
                            <Grid item >
                                <Button
                                    color="secondary"
                                    size="small"
                                    variant="contained"
                                    onClick={() => { close(item) }}>
                                    Cancelar
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </DialogActions>
            </Dialog>

        </Fragment>
    );
};

export default EditImage;


